import LabServiceCollection from "@/collections/LabServiceCollection";
import ResultImportModel from "@/models/lab/ResultImportModel";

export default class ResultImportCollection extends LabServiceCollection {

  model() {
    return ResultImportModel;
  }

}
